import { h } from "@stencil/core";

/**
 * Replaces the specified text snippets with <a> href links
 * @param inputText
 * @param wordToReplace
 * @param linkText
 * @param linkPath
 * @param linkTarget
 */
export const replaceHtmlLinks = (inputText: string, wordToReplace: string, linkText: string, linkPath?: string, linkTarget?: string) => {
	const regex: RegExp = new RegExp(`(${wordToReplace})`, "g");
	const textArray = inputText.split(regex);

	return textArray.map(textPart => {
		if (regex.test(textPart)) {
			return (
				<bbg-link target={linkTarget} href={linkPath}>
					{linkText}
				</bbg-link>
			);
		}

		return textPart;
	});
};
